export default {
  Title: "Bảo mật nâng cao",
  Force: "Bắt buộc xác thực 2 yếu tố khi đăng nhập",
  Noti: "Khi nhân viên đăng nhập phần mềm sẽ yêu cầu thiết lập 2 yếu tố nếu chưa bật.",
  All: "Tất cả người dùng",
  Selected: "Chỉ người dùng được chọn",
  Confirm: "XÁC THỰC 2 YẾU TỐ (2FA)"
};
